import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import baseStore from "./baseStore";
import homeStore from "home/homeStore"
import recruitStore from "recruit/recruitStore"
import liveStore from "live/liveStore"
import meetingStore from "meeting/meetingStore"
import imStore from "im/imStore"
import questionnaireStore from "questionnaire/questionnaireStore"
import loginStore from "login/loginStore"
import companyStore from "company/companyStore"
import companyManageStore from "companyManage/companyManageStore"
import studentManageStore from "studentManage/studentManageStore"
import noticeStore from "notice/noticeStore"
import systemConfigStore from "systemConfig/systemConfigStore"
import studentStore from "student/studentStore"

export default new Vuex.Store({
  modules:{
    baseStore,
    homeStore,
    recruitStore,
    liveStore,
    meetingStore,
    imStore,
    questionnaireStore,
    loginStore,
    companyStore,
    companyManageStore,
    studentManageStore,
    noticeStore,
    systemConfigStore,
    studentStore
  }
});
